import React from 'react';
import '../style/Lobby.css';

function UserList({ users, onToggleSpectator, currentUserId, onKickUser }) {
    return (
        <div className="userlist">
            <h2>Teilnehmer:</h2>
            <ul className="userlist-ul">
                {users.map((user) => (
                    <li
                        key={user.persistentId}
                        className={`user-item ${user.isDisconnected ? 'disconnected' : ''}`}
                    >
                        <span className="user-name">
                            {user.name}
                            {user.persistentId === currentUserId && <span className="self-indicator"> (ich)</span>}
                        </span>
                        <div className="badge-container">
                            {user.isCreator ? (
                                <span className="badge creator">
                                    <i className="fas fa-crown"></i> Creator
                                </span>
                            ) : (
                                <>
                                    <span
                                        className={`badge ${user.persistentId === currentUserId ? 'clickable' : ''} ${user.isSpectator ? 'spectator' : 'player'}`}
                                        onClick={() => user.persistentId === currentUserId && onToggleSpectator(user.persistentId)}
                                        title={user.persistentId === currentUserId ? "Klicken zum Ändern" : undefined}
                                    >
                                        <i className={`fas ${user.isSpectator ? 'fa-eye' : 'fa-gamepad'}`}></i>
                                        {user.isSpectator ? ' Zuschauer' : ' Spieler'}
                                    </span>
                                    {onKickUser && user.persistentId !== currentUserId && (
                                        <button
                                            className="kick-button"
                                            onClick={() => onKickUser(user.persistentId)}
                                            title="Spieler kicken"
                                        >
                                            <i className="fas fa-times"></i>
                                            Kick
                                        </button>
                                    )}
                                </>
                            )}
                            {user.isDisconnected && (
                                <span className="badge disconnected">
                                    <i className="fas fa-door-open"></i> Verlassen
                                </span>
                            )}
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default React.memo(UserList);
